import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CONTRACTOR_LOCATIONS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('CONTRACTOR_LOCATIONS');
export const CONTRACTOR_LOCATIONS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CONTRACTOR_LOCATIONS_CRUD_ACTION_CONSTANTS
);
